import { TextField } from '@material-ui/core';

import { DELIVERY_ZONE_NAME_ERROR, DELIVERY_ZONE_NAME_MAX_LENGTH } from '../../utils/delivery-zone-form-rules.util';
import { DeliveryZoneCard } from './DeliveryZoneCard.component';

type Props = {
  name: string;
  isArchived: boolean;
  isNameInvalid: boolean;
  onNameChange: (name: string) => void;
};

export function DeliveryZoneInformationsCard({ name, isArchived, isNameInvalid, onNameChange }: Props) {
  return (
    <DeliveryZoneCard title="Informations">
      <TextField
        id="delivery-zone-name"
        label="Nom"
        type="text"
        size="small"
        variant="outlined"
        fullWidth
        disabled={isArchived}
        inputProps={{ maxLength: DELIVERY_ZONE_NAME_MAX_LENGTH }}
        error={isNameInvalid}
        helperText={isNameInvalid ? DELIVERY_ZONE_NAME_ERROR : undefined}
        value={name}
        onChange={(event) => onNameChange(event.target.value)}
      />
    </DeliveryZoneCard>
  );
}
